<dx-popup
  [(visible)]="visible"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.TITLE' | translate"
  [width]="'90dvw'"
  [height]="'95dvh'">

  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button [stylingMode]="'contained'" [type]="'default'"
               icon="save" text="{{'BUTTONS.SAVE' | translate}}" (onClick)="onSaveClick()"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}" (onClick)="onCancelClick()"></dx-button>
  </dxi-toolbar-item>

  <div class="compareRoot">

    <div class="compareHeader">
      <div class="compareHeaderHalf">
        <dx-select-box
          [dataSource]="filteredDeviceTypes"
          [(value)]="selectedDeviceTypeId"
          displayExpr="label"
          valueExpr="id"
          [searchEnabled]="true"
          itemTemplate="deviceTypeItem"
          [label]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.REFERENCE_TYPE' | translate"
          class="deviceTypeSelector">
          <div *dxTemplate="let data of 'deviceTypeItem'" class="flexRow">
            <span>{{ data.label }}</span>
            <span *ngIf="data.id === referenceType" class="currentReferenceBadge">{{ 'REGISTRY.DEVICE.TEMPLATE_IMPORT.CURRENT_REFERENCE' | translate }}</span>
          </div>
        </dx-select-box>

        <div class="referenceToggle">
          <dx-switch
            [value]="useAsReferenceType"
            [disabled]="selectedDeviceTypeId === referenceType"
            (onValueChanged)="onUseAsReferenceToggle($event.value)">
          </dx-switch>
          <span>{{ 'REGISTRY.DEVICE.TEMPLATE_IMPORT.SET_AS_REFERENCE' | translate }}</span>
        </div>
      </div>
      <div class="compareHeaderSpacer">
        <dx-button [stylingMode]="'contained'" [type]="'default'"
                   icon="refresh" text="{{'REGISTRY.DEVICE.TEMPLATE_IMPORT.RESET_BUTTON' | translate}}" (onClick)="resetFromModel.emit(selectedDeviceTypeId)"></dx-button>
      </div>
    </div>

    <div class="compareQuadrants">

      <!-- Template (left) column -->
      <div class="compareColumn">
        <div class="compareCell group">
          <app-measure-group-table
            [groups]="templateGroupRows"
            [protocolType]="deviceProtocol"
            [selectedGroup]="selectedTemplateGroup"
            [showAction]="true"
            emptyMessageKey="REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_TEMPLATE_GROUPS"
            (groupClick)="onTemplateGroupClick($event)"
            (addGroup)="onAddGroup($event)"
            (addAllGroups)="onAddAllGroups($event)">
          </app-measure-group-table>
        </div>
        <div class="compareCell metric">
          <app-measure-metric-table
            [metrics]="templateMetricRows"
            [protocolType]="deviceProtocol"
            [groupTransportConfiguration]="selectedTemplateGroup?.transportConfiguration"
            [groupName]="selectedTemplateGroup?.name"
            [showAction]="true"
            [showSyncStatus]="true"
            [emptyMessageKey]="selectedTemplateGroupId? 'REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_METRICS' : 'REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.SELECT_GROUP'"
            (addMetric)="onAddMetric($event)"
            (replaceMetric)="onReplaceMetric($event)"
            (addAllMetrics)="onAddAllMetrics($event)">
          </app-measure-metric-table>
        </div>
      </div>

      <!-- Device (right) column -->
      <div class="compareColumn">
        <div class="compareCell group">
          <app-measure-group-table
            [groups]="deviceGroups"
            [protocolType]="deviceProtocol"
            [selectedGroup]="selectedDeviceGroup"
            [showAction]="false"
            [showActiveColumn]="false"
            [showDelete]="true"
            [titleSuffix]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.DEVICE_COLUMN_TITLE' | translate"
            emptyMessageKey="REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_DEVICE_GROUPS"
            (groupClick)="onDeviceGroupClick($event)"
            (deleteGroup)="onDeleteDeviceGroup($event)">
          </app-measure-group-table>
        </div>
        <div class="compareCell metric">
          <app-measure-metric-table
            [metrics]="selectedDeviceGroup?.metrics || []"
            [protocolType]="deviceProtocol"
            [groupTransportConfiguration]="selectedDeviceGroup?.transportConfiguration"
            [groupName]="selectedDeviceGroup?.name"
            [showAction]="false"
            [showActiveColumn]="false"
            [showSyncStatus]="false"
            [showDelete]="!!selectedDeviceGroup"
            [titleSuffix]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.DEVICE_COLUMN_TITLE' | translate"
            [emptyMessageKey]="selectedDeviceGroup? 'REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_METRICS' : 'REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.SELECT_GROUP'"
            (deleteMetric)="onDeleteDeviceMetric($event)">
          </app-measure-metric-table>
        </div>
      </div>

    </div>
  </div>

</dx-popup>
